// libraries
import React, { useEffect } from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'
import Mask from '/react4xp/components/Mask'
import Balloon from '/react4xp/components/Balloon'

// prop types
interface QIdeaHeroProps {
    title: string
    subTitle?: {
        textTop: string
        number: string
        textBottom: string
    }
    src?: string
    srcMedium?: string
    alt?: string
}

export default function QIdeaHero({
    title,
    subTitle,
    src,
    srcMedium,
    alt
}: QIdeaHeroProps) {

    useEffect(() => {
		const qideaBody = document.querySelector('.page-q-idea--home .q-idea-hero');

        if (qideaBody) {
            if (!src) {
                qideaBody.classList.add('hero--no-image');
            } else {
                qideaBody.classList.remove('hero--no-image');
            }
        }
	}, [src])
    
    return (
        <div className={clsx('q-idea-hero', src && 'q-idea-hero--with-image')}>

            {title && (
                <Balloon
                    arrow={src ? 'bottom-right' : 'bottom-left'}
                    arrowSize='medium'
                    arrowSide={src ? 'left' : 'right'}
                    balloonColor='white'
                    spacing='medium'
                    balloonSide={src ? 'right' : 'left'}
                    className='q-idea-hero__title'
                >
                    <h1 className='h1-hero-big'>
                        {title}
                    </h1>
                </Balloon>  
            )}

            {src && (
                <Mask className='q-idea-hero__image'>
                    <Image
                        src={src}
                        srcMedium={srcMedium}
                        alt={alt}
                        width={800}
                        className='cover'
                    />
                </Mask>
            )}

            <Balloon
                arrow='bottom-middle'
                arrowSize='small'
                arrowSide={src ? 'right' : 'left'}
                balloonColor='blue-dark'
                spacing={src ? 'medium' : 'smaller'}
                balloonSide={src ? 'left' : 'right'}
                className='q-idea-hero__subtitle'
            >
                <p className='text-big bold text-top'>
                    {subTitle.textTop}
                </p>

                <p className='h1-hero-small number'>
                    {subTitle.number}
                </p>

                <p className='text-big bold text-bottom'>
                    {subTitle.textBottom}
                </p>

            </Balloon>

            <div className='cf'></div>

        </div>
    )
}